/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkTrackResponseDtoFromJSON, BulkTrackResponseDtoToJSON, } from './BulkTrackResponseDto';
/**
 * Check if a given object implements the BulkTracksResponseDto interface.
 */
export function instanceOfBulkTracksResponseDto(value) {
    if (!('tracks' in value) || value['tracks'] === undefined)
        return false;
    if (!('failed' in value) || value['failed'] === undefined)
        return false;
    return true;
}
export function BulkTracksResponseDtoFromJSON(json) {
    return BulkTracksResponseDtoFromJSONTyped(json, false);
}
export function BulkTracksResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tracks': (json['tracks'].map(BulkTrackResponseDtoFromJSON)),
        'failed': json['failed'],
    };
}
export function BulkTracksResponseDtoToJSON(json) {
    return BulkTracksResponseDtoToJSONTyped(json, false);
}
export function BulkTracksResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tracks': (value['tracks'].map(BulkTrackResponseDtoToJSON)),
        'failed': value['failed'],
    };
}
